import { Icons, Progress } from '@agro-club/agroclub-shared'
import { useAProgress } from 'hooks/useAProgress'
import { useNotification } from 'hooks/useNotification'
import { AuthContext } from 'modules/context/AuthContext'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { AButton } from 'views/components/Analytics'

interface ButtonProps {
  taskId: string
  onSuccess: () => void
  potential_executors?: string[]
}

export const SetTaskToWorkButton: FC<ButtonProps> = ({ taskId, onSuccess, potential_executors }) => {
  const { t } = useTranslation(['my_tasks', 'common'])
  const notify = useNotification()
  const { profile: currentUser } = useContext(AuthContext)

  const [progress, setToWork] = useAProgress(() => apiClient.post(endpoints.setTaskToWork(taskId)), {
    eventName: 'setToWork',
    analyticsPayload: {
      id: taskId,
    },
    onSuccess: () => {
      onSuccess()
      notify(Progress.SUCCESS, { title: t('table.set_to_work_task') })
    },
    onError: () => notify(Progress.ERROR, { title: t('common:notifyError') }),
  })

  return (
    <AButton
      id="setToWork"
      size="small"
      color="secondary"
      Icon={Icons.IconDone}
      onClick={setToWork}
      progress={progress}
      disabled={currentUser && !potential_executors?.includes(currentUser.id)}
    >
      {t('table.to_work')}
    </AButton>
  )
}
